import { render, staticRenderFns } from "./saveEmployee.vue?vue&type=template&id=70d2aceb&"
import script from "./saveEmployee.vue?vue&type=script&lang=js&"
export * from "./saveEmployee.vue?vue&type=script&lang=js&"
import style0 from "./saveEmployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports